import { render, staticRenderFns } from "./ExpenseCategorySetting.vue?vue&type=template&id=0d61b2ba&"
import script from "./ExpenseCategorySetting.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategorySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d61b2ba')) {
      api.createRecord('0d61b2ba', component.options)
    } else {
      api.reload('0d61b2ba', component.options)
    }
    module.hot.accept("./ExpenseCategorySetting.vue?vue&type=template&id=0d61b2ba&", function () {
      api.rerender('0d61b2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/ExpenseCategorySetting.vue"
export default component.exports